var map = {
	"./axolotl/angry.webp": 49626,
	"./axolotl/happy.webp": 2197,
	"./axolotl/hungry.webp": 41988,
	"./axolotl/idle.webp": 80019,
	"./axolotl/sad.webp": 68679,
	"./axolotl/sleepy.webp": 58787,
	"./axolotl/surprised.webp": 35366,
	"./cat/angry.webp": 63129,
	"./cat/happy.webp": 22282,
	"./cat/hungry.webp": 51973,
	"./cat/idle.webp": 73366,
	"./cat/sad.webp": 3796,
	"./cat/sleepy.webp": 73722,
	"./cat/surprised.webp": 59401,
	"./fox/angry.webp": 93684,
	"./fox/happy.webp": 44747,
	"./fox/hungry.webp": 34666,
	"./fox/idle.webp": 21885,
	"./fox/sad.webp": 19001,
	"./fox/sleepy.webp": 72233,
	"./fox/surprised.webp": 4876,
	"./hamster/angry.webp": 20179,
	"./hamster/happy.webp": 57256,
	"./hamster/hungry.webp": 96955,
	"./hamster/idle.webp": 60312,
	"./hamster/sad.webp": 67902,
	"./hamster/sleepy.webp": 80984,
	"./hamster/surprised.webp": 64231,
	"./hedgehog/angry.webp": 82390,
	"./hedgehog/happy.webp": 24209,
	"./hedgehog/hungry.webp": 5504,
	"./hedgehog/idle.webp": 97647,
	"./hedgehog/sad.webp": 84555,
	"./hedgehog/sleepy.webp": 18751,
	"./hedgehog/surprised.webp": 66442,
	"./owl/angry.webp": 56491,
	"./owl/happy.webp": 48224,
	"./owl/hungry.webp": 7763,
	"./owl/idle.webp": 8160,
	"./owl/sad.webp": 83062,
	"./owl/sleepy.webp": 31264,
	"./owl/surprised.webp": 87599,
	"./penguin/angry.webp": 95713,
	"./penguin/happy.webp": 51858,
	"./penguin/hungry.webp": 84557,
	"./penguin/idle.webp": 43630,
	"./penguin/sad.webp": 30972,
	"./penguin/sleepy.webp": 28402,
	"./penguin/surprised.webp": 95425,
	"./platypus/angry.webp": 12391,
	"./platypus/happy.webp": 22428,
	"./platypus/hungry.webp": 23455,
	"./platypus/idle.webp": 51052,
	"./platypus/sad.webp": 96266,
	"./platypus/sleepy.webp": 30636,
	"./platypus/surprised.webp": 50515,
	"./raccoon/angry.webp": 18168,
	"./raccoon/happy.webp": 20431,
	"./raccoon/hungry.webp": 41966,
	"./raccoon/idle.webp": 41361,
	"./raccoon/sad.webp": 64917,
	"./raccoon/sleepy.webp": 98685,
	"./raccoon/surprised.webp": 67064,
	"./sharpei/angry.webp": 80387,
	"./sharpei/happy.webp": 16984,
	"./sharpei/hungry.webp": 62187,
	"./sharpei/idle.webp": 200,
	"./sharpei/sad.webp": 14,
	"./sharpei/sleepy.webp": 43176,
	"./sharpei/surprised.webp": 66295,
	"./sloth/angry.webp": 35933,
	"./sloth/happy.webp": 9934,
	"./sloth/hungry.webp": 81385,
	"./sloth/idle.webp": 33978,
	"./sloth/sad.webp": 52000,
	"./sloth/sleepy.webp": 32958,
	"./sloth/surprised.webp": 99557,
	"./turtle/angry.webp": 46025,
	"./turtle/happy.webp": 73370,
	"./turtle/hungry.webp": 7349,
	"./turtle/idle.webp": 1478,
	"./turtle/sad.webp": 17828,
	"./turtle/sleepy.webp": 99626,
	"./turtle/surprised.webp": 38457
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69190;